import React from 'react';
import {Component} from 'react';
import {connect} from 'react-redux';
import _ from "lodash";
import ReactTable from 'react-table';
import "react-table/react-table.css";

import FilingReportTypeSelector from '../Generic/ReportTypeSelector';
import FILING_CONTROLLER from '../../../controllers/filing';
import CONTENT_CONTROLLER from '../../../controllers/content';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../../utils/logger';
import DrilldownModal from '../Generic/DrilldownModal';
import {LocalListingFlowEnum, FilingTypeEnum,VATNumberChecksEnum} from '../../../utils/enums';
import Pagination from '../../page/Pagination';
import NoData from '../../page/NoData';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';

const log = new Logger('REVERSE_CHARGE_LISTING_FILING_VALUES', LOG_LEVELS.DEBUG);

class ReverseChargeListingFilingValues extends Component {

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, { showDrilldown: false, isRequestIdSelected :true, selectedVatNumber: ''});
    }

    openDrilldown(lineDetails) {
            const params = {
                filingTypeId: FilingTypeEnum.REVERSECHARGELISTING,
                countryCode: this.props.countryCode,
                companyId: this.props.companyId,
                dueDate: this.props.filingDueDate,
                startDate: this.props.filingPeriod && this.props.filingPeriod.fromDate,
                endDate: this.props.filingPeriod && this.props.filingPeriod.toDate,
                vatNumber: lineDetails.vatNumber,
                flowType: lineDetails.flowType,
                listingLineType: lineDetails.lineType
            };
            this.props.doOnLineSelect(params);
            this.setState({
                showDrilldown: true,
                selectedVatNumber: lineDetails.vatNumber
            });
    }

    closeDrilldown() {
        this.setState({
            showDrilldown: false,
            selectedVatNumber: ''
        });
    }

    onDrilldown(row){
        log.debug('onDrilldown: row.original: ', row.original);
        const lineDetails = (this.props.filingValues.lines && this.props.filingValues.lines[row.index]) || {};
        this.openDrilldown(lineDetails);
      }

    UNSAFE_componentWillMount() {
        this.props.onPageLoad();
    }
    checkVATNumbers(criteria, msInterval,event) {
        log.debug("checkVATNumbers: criteria %s msInterval %s", criteria, msInterval );
        let requesterVATNumber = this.props.vatNumber;
        function onlyUnique(value,index,self) {
          return self.indexOf(value) === index;
        }
        let vrns = [];
        switch (criteria) {
          case 'all':
            vrns = this.props.filingValues.lines.map(item => item.vatNumber).filter(onlyUnique);
            break;
          case 'failed':
            vrns = this.props.checkedVATNumbers.filter(item => !item.isValid).map(item => item.vrn);
            break;
          default:      // No criteria is a single VAT Number to check
            vrns = [criteria];
            msInterval = 0;
        }
        if(this.state.isRequestIdSelected){
          vrns.forEach((vrn, counter) => {
            // Set a timeout on the request to stagger the calls by msInterval
            setTimeout(() => {
              this.props.checkVATNumberWithRequestId(vrn,requesterVATNumber);
            }, counter * msInterval);
          });
        } else {
          vrns.forEach((vrn, counter) => {
            // Set a timeout on the request to stagger the calls by msInterval
            setTimeout(() => {
              this.props.checkVATNumber(vrn);
            }, counter * msInterval);
          });
        }
    }
    onRequestIdChangeHandler(){
        this.setState({ isRequestIdSelected: !this.state.isRequestIdSelected });
    }
    componentDidUpdate(prevProps) {
        if(!this.state.isRequestIdSelected && prevProps.frequency !== this.props.frequency){
          this.setState({ isRequestIdSelected: true });
        }
    }

    getModalTitle(reportTypeLabel){
        const modalTitle =  LANGUAGES_CONTROLLER.format(this.props.languages, 'reverseChargeListingDrillDownModal_ReverseChargeListing') + ' '
                            + reportTypeLabel + ' '
                            + LANGUAGES_CONTROLLER.format(this.props.languages, 'reverseChargeListingDrillDownModal_LineDetails');
        return modalTitle;
    }

    onSelectReportType(e) {
        log.debug('onSelectReportType(): ', e);
        log.debug('onSelectReportType(): selectedKey:',  e.target.value);
        if(typeof this.props.onReportChangeHandler === 'function') {
            this.setState({ isRequestIdSelected: true });
            this.props.onReportChangeHandler(
                {selectedReportType: e.target.value }
            );
        }
    }

    render() {
        log.debug('render(): ', this.props);

        const filingValues = (this.props.filingValues && this.props.filingValues.lines) || [];
        const modalTitle = this.getModalTitle(this.props.selectedReportType ? LANGUAGES_CONTROLLER.format(this.props.languages, this.props.selectedReportType) : '');
        const revChargeListingData = filingValues.map( (revChargeListingRow) => {

        let checkResultsForThisNumber = (this.props.checkedVATNumbers && Object.values(this.props.checkedVATNumbers).filter(item => item.vrn === revChargeListingRow.vatNumber)) || [];

        let thisVATNumberIsValid = (checkResultsForThisNumber[0] && checkResultsForThisNumber[0].isValid) ;

        revChargeListingRow.VATNumberCheckDetails = {};

        switch (thisVATNumberIsValid){
            case true:
                revChargeListingRow.VATNumberCheckDetails.isValid = "";
                revChargeListingRow.VATNumberCheckDetails.companyName = checkResultsForThisNumber[0].name;
                revChargeListingRow.VATNumberCheckDetails.extraInfo = checkResultsForThisNumber[0].street + ', ' + checkResultsForThisNumber[0].city;
                revChargeListingRow.vatNumberCheck = VATNumberChecksEnum.getValue("OK");
                revChargeListingRow.VATNumberCheckDetails.requestIdentifier = checkResultsForThisNumber[0].requestIdentifier;
                revChargeListingRow.VATNumberCheckDetails.viesCheckDateTime = checkResultsForThisNumber[0].viesCheckDateTime;
              break;
            case false:
                revChargeListingRow.VATNumberCheckDetails.isValid = "false";
                revChargeListingRow.VATNumberCheckDetails.companyName = "";
                revChargeListingRow.VATNumberCheckDetails.extraInfo = checkResultsForThisNumber[0].errorMessage;
                revChargeListingRow.vatNumberCheck = VATNumberChecksEnum.getValue("FAILED");

              break;
            default:
                revChargeListingRow.VATNumberCheckDetails.isValid = "";
                revChargeListingRow.VATNumberCheckDetails.companyName = "";
                revChargeListingRow.vatNumberCheck = VATNumberChecksEnum.getValue("NOT_CHECKED");
                revChargeListingRow.VATNumberCheckDetails.extraInfo = VATNumberChecksEnum.getString("NOT_CHECKED");
          }

          if (this.props.checkVATNumbersInProgress.includes(revChargeListingRow.vatNumber)){
            revChargeListingRow.VATNumberCheckDetails.isValid = "";
            revChargeListingRow.VATNumberCheckDetails.companyName = "";
            revChargeListingRow.VATNumberCheckDetails.extraInfo = <LanguageStringResolver string='localListingFilingValues_InProgress'/>;
          }

          return {
                vatNumber: revChargeListingRow.vatNumber,
                taxableBasis: revChargeListingRow.taxableBasis || 0.0,
                vatReversed: revChargeListingRow.vatReversed || 0.0,
                vatNumberCheck: revChargeListingRow.vatNumberCheck,
                lineTypeAsString:revChargeListingRow.lineTypeAsString,
                name:  revChargeListingRow.name,
                companyCheck: revChargeListingRow.VATNumberCheckDetails.companyName,
                extraInfo: revChargeListingRow.VATNumberCheckDetails.extraInfo,
                flowType: revChargeListingRow.flowTypeDescription,
                requestIdentifier:revChargeListingRow.VATNumberCheckDetails.requestIdentifier,
                viesCheckDateTime:revChargeListingRow.VATNumberCheckDetails.viesCheckDateTime
            };
        });

        const cols = [
            { Header:  <span><LanguageStringResolver string='revChargeListingFilingReportType_VATNumber' /></span>, accessor: 'vatNumber',
                Cell: row => ( <button className="tertiary" onClick={this.onDrilldown.bind(this, row)} > {row.value} </button> ),
                Footer: (
                <div style={{width: '100%', textAlign: 'right'}}>
                    <strong><LanguageStringResolver string='revChargeListingFilingReportType_TotalAmount'/>:&nbsp;</strong>{" "}
                </div>
              )
            },
            { Header: <span><LanguageStringResolver string='revChargeListingFilingReportType_TaxableBasis' /></span>,
                accessor: 'taxableBasis',
                Cell: row => (
                    <span>{parseFloat(row.value).toFixed(2)}</span>
                ),
                Footer: (
                    <span>{parseFloat(Math.round( _.sum(_.map(revChargeListingData, d => d.taxableBasis)) * 100) / 100).toFixed(2)}</span>
                )
            },
            {   Header:<span><LanguageStringResolver string='revChargeListingFilingReportType_VatReversed' /></span> ,
                accessor: 'vatReversed',
                Cell: row => (
                    <span>{parseFloat(row.value).toFixed(2)}</span>
                )
            },
            { Header: <span><LanguageStringResolver string='revChargeListingFilingReportType_InOut' /></span> , accessor: 'lineTypeAsString' },
            { Header: <span><LanguageStringResolver string='reverseChargeListingFilingReportType_VATNumberCheck' /></span>, minWidth:180, accessor: 'vatNumberCheck',
                Cell: row => (
                <span>
                    {row.original.vatNumberCheck === VATNumberChecksEnum.getValue("NOT_CHECKED")
                                || row.original.vatNumberCheck === VATNumberChecksEnum.getValue("FAILED") ? (
                    <button className="link bold" onClick={this.checkVATNumbers.bind(this,row.original.vatNumber,0)}>
                        <LanguageStringResolver string='reverseChargeListingFilingReportType_CheckOnline' />
                    </button>
                    ) : (
                    row.original.vatNumberCheck === VATNumberChecksEnum.getValue("OK") ? (
                        (row.original.requestIdentifier !== undefined)?
                        <span>{row.original.viesCheckDateTime + '-'}<LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("OK")} />{ '-' + row.original.requestIdentifier}</span>
                        :<span><LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("OK")} /></span>
                    ) : (<span><LanguageStringResolver string='vatNumberCheckStatus_Unknown' /></span>)
                    )}
                </span>
            )},
            { Header: <span><LanguageStringResolver string='revChargeListingFilingReportType_Name' /></span>, accessor: 'name' },
            { Header: <span><LanguageStringResolver string='revChargeListingFilingReportType_CompanyCheck' /></span>, accessor: 'companyCheck'},
            { Header: <span><LanguageStringResolver string='reverseChargeListingFilingReportType_ExtraInfo' /></span>, accessor: 'extraInfo',
              Cell: row => (
                <span>
                {
                  (row.original.vatNumberCheck === VATNumberChecksEnum.getValue("FAILED")) ? (
                    row.original.extraInfo === null
                      ? (<span><LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("FAILED")} /></span>)
                      : (
                        (row.original.extraInfo !== <LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("FAILED")} />)
                          ? (<span>{row.original.extraInfo}</span>)
                          : (<span><LanguageStringResolver string='reverseChargeListingFilingReportType_ServiceError'/>: {row.original.extraInfo}</span>)
                      )
                    )
                  : (<span>{row.original.extraInfo}</span>)
                }
                </span>
              )
            },
            { Header: <span><LanguageStringResolver string='revChargeListingFilingReportType_FlowType' /></span>,
                accessor: 'flowType',
                style: {overflow: "visible", whiteSpace: "normal"},
                width: 320 }
          ];

        // DrillDown Modal
        const filingValueDetails = (this.props.filingValueDetails && this.props.filingValueDetails.lines) || [];
        const drillDownData = filingValueDetails.map((valueDetailEntry) =>  {
            return {
                invoiceNumber: valueDetailEntry.invoiceNumber,
                invoiceDate: valueDetailEntry.invoiceDate,
                amount: valueDetailEntry.amount,
                amountVAT: valueDetailEntry.amountVAT,
                supplierInvoiceNumber: valueDetailEntry.supplierInvoiceNumber
            };
        });
        const drillDownCols = [
            {
                Header: (<span><LanguageStringResolver string='reverseChargeListingDrillDownModal_InvoiceNr' /></span>),
                accessor: "invoiceNumber",  minWidth: 100
            },
            {
                Header: (<span><LanguageStringResolver string='reverseChargeListingDrillDownModal_InvoiceDate' /></span>),
                accessor: "invoiceDate",
                Footer: (
                    <span>
                        <strong><LanguageStringResolver string='reverseChargeListingDrillDownModal_Total' /></strong>: {''}
                    </span>
                )
            },
            {
                Header: (<span><LanguageStringResolver string='reverseChargeListingDrillDownModal_Amount' /></span> ),
                accessor: "amount",
                Cell: row => (
                    <span>{parseFloat(row.value).toFixed(2)}</span>
                ),
                Footer: (<span>{parseFloat(_.sum(_.map(drillDownData, d => d.amount))).toFixed(2)}</span>)
            },
            {
                Header: (<span><LanguageStringResolver string='reverseChargeListingDrillDownModal_SupplierInvoiceNr' /></span>),
                accessor: "supplierInvoiceNumber"
            }
            ];

        const modalStyle = {
            modal: 'modal-full-width modal-max-width-75'
        };

        const NoDataComponent = props => (
            <NoData
                noDataText="filingValues_noData"
                {...props}
            />
            );
        return (
            <div>
                <s-row>
                    <s-col span="6">
                        <fieldset>
                            <label>{LANGUAGES_CONTROLLER.format(this.props.languages, 'filingReportType_ReportType')}</label>
                            <FilingReportTypeSelector flowTypes={Object.keys(LocalListingFlowEnum.props).filter((el) => el !== LocalListingFlowEnum.NONE)} selectValue={this.props.selectedReportType}
                                onChange={(e) => this.onSelectReportType(e)}></FilingReportTypeSelector>
                        </fieldset>
                        <div className="mt20 mb20">
                            <button className="link" onClick={this.checkVATNumbers.bind(this, 'all', 150)}>
                            <LanguageStringResolver string='reverseChargeListingFilingReportType_CheckAll'/>
                            </button>
                            {(this.props.checkedVATNumbers.filter(item => !item.isValid).length === 0) ? (
                            <span></span>
                            ) : (
                            <span>
                                <span className="divider-left margin-left-sm margin-right-sm"></span>
                                <button className="tertiary" onClick={this.checkVATNumbers.bind(this, 'failed', 150)}>
                                <LanguageStringResolver string='reverseChargeListingFilingReportType_CheckFailed'/>
                                </button>
                            </span>
                            )}
                            <span className="divider-left margin-left-sm margin-right-sm"></span>
                            <fieldset className="inline">
                            <input className="checkbox" type="checkbox" id="r1" checked ={this.state.isRequestIdSelected} onClick={this.onRequestIdChangeHandler.bind(this)} aria-checked="false" />
                            <label className="checkbox" ><LanguageStringResolver string='reverseChargeListingFilingReportType_RequestID'/></label>
                            </fieldset>
                        </div>
                    </s-col>
                </s-row>
                <ReactTable
                    data={revChargeListingData}
                    columns={cols}
                    className={'mb15'}
                    defaultPageSize={20}
                    minRows={0}
                    maxRows={0}
                    pageSizeOptions={[ 20, 50, 100, 1000]}
                    showPagination={revChargeListingData.length !== 0}
                    PaginationComponent={Pagination}
                    resizable={true}
                    sortable={false}
                    noDataText={LANGUAGES_CONTROLLER.format(this.props.languages, 'revChargeListingFilingReportType_NoData')}
                    NoDataComponent={NoDataComponent}
                />

                  <DrilldownModal open={this.state.showDrilldown}
                                  onClose={this.closeDrilldown.bind(this)}
                                  title={modalTitle}
                                  cols={drillDownCols} data={drillDownData}
                                  companyId={this.props.companyId} vatNumber={this.state.selectedVatNumber}
                                  modalStyles={modalStyle} />

                  <br/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    log.debug('mapStateToProps(): ', state);
    const stateProps = {
        languages: state.languages,
        filingValueDetails: state.filing.filingValueDetails || {},
        reportTypes: CONTENT_CONTROLLER.getFilingReportTypes(state.content, FilingTypeEnum.REVERSECHARGELISTING) || [],
        checkedVATNumbers: state.filing.checkedVATNumbers || {},
        checkVATNumbersInProgress: state.filing.checkVATNumbersInProgress || []

    };
    return stateProps;
}

function mapDispatchToProps(dispatch) {
    log.debug('mapDispatchToProps(): ');
    const dispatchProps = {
        onPageLoad: () => {
            log.debug("onPageLoad(): ");
        },
        doOnLineSelect: (params) => {
            log.debug("doLineSelect(): params: ", params);
            dispatch(FILING_CONTROLLER.doLoadReverseChargeListingValueDetails({
                companyId: params.companyId,
                countryCode: params.countryCode,
                startDate: params.startDate,
                endDate: params.endDate,
                vatNumber: params.vatNumber,
                flowType: params.flowType,
                listingLineType: params.listingLineType
            }));

        },
        checkVATNumber: (vatNumber) => {
            log.debug("checkVATNumber: vatNumber: ", vatNumber);
            dispatch(FILING_CONTROLLER.checkVATNumber(vatNumber))
        },
        checkVATNumberWithRequestId: (vatNumber, requesterVATNumber) => {
            log.debug("checkVATNumber: vatNumber: requesterVATNumber", vatNumber, requesterVATNumber);
            dispatch(FILING_CONTROLLER.checkVATNumberWithRequestId(vatNumber, requesterVATNumber))
        },
    };
    return dispatchProps;
}


export default connect(mapStateToProps, mapDispatchToProps)(ReverseChargeListingFilingValues);
